import { render, staticRenderFns } from "./CovidResponse.vue?vue&type=template&id=1247f6d5&"
import script from "./CovidResponse.vue?vue&type=script&lang=js&"
export * from "./CovidResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports